<template>
  <main>
    <datepicker :disabled="sending"
                :required="required"
                :value="dateValue"
                :format="format"
                :clear-button="clearButton"
                :language="lang"
                :disabled-dates="invalidDates"
                :use-utc="false"
                @input="inputDatetime">
      <label v-if="label">{{ label }}</label>
    </datepicker>
  </main>
</template>

<script>
import moment     from "moment";
import Datepicker from "vuejs-datepicker"
import {ja}       from 'vuejs-datepicker/dist/locale'

export default {
  name      : "DatePicker",
  components: {
    Datepicker
  },
  props     : {
    value        : null,
    label        : {
      type    : String,
      required: false,
      default : null,
    },
    sending      : {
      type    : Boolean,
      required: false,
      default : false,
    },
    required     : {
      type    : Boolean,
      required: false,
      default : false,
    },
    format       : {
      type    : String,
      required: false,
      default : 'yyyy-MM-dd',
    },
    disabledDates: {
      type    : Object,
      required: false,
      default : () => ({}),
    },
    clearButton  : {
      type    : Boolean,
      required: false,
      default : true,
    },
  },
  data      : () => ({
    dateValue   : null,
    initValue   : null,
    lang        : null,
    invalidDates: null,
  }),
  created() {
    this.dateValue    = this.value;
    this.initValue    = this.value;
    this.lang         = ja;
    this.invalidDates = this.disabledDates;
  },
  methods: {
    /**
     * 日付の入力を親コンポーネントに渡す
     * @param value
     */
    inputDatetime: function (value) {
      this.$emit('input', value)
    },
    /**
     * 日付を整形して再表示する
     * @param value
     */
    formatDateValue: function (value) {
      const numberMaxLength = this.$props.format === 'yyyy-MM-dd' ? 12 : 8;

      // 数字と半角スペースとハイフンのみ入力を許す
      const numberHyphenOnly = value.replace(/[^\d\s\-:]/g, ' ');
      if (numberHyphenOnly !== value) {
        this.dateValue = numberHyphenOnly;
        return;
      }

      // 数値だけで8桁(12桁)ない場合は処理しない
      const numberOnly = value.match(/\d/ig) ? value.match(/\d/ig).join('') : '';
      if (numberOnly === '' || numberOnly.length < numberMaxLength) {
        return;
      }

      // 日付でない場合は初期化
      if (numberOnly.length === numberMaxLength && !moment(numberHyphenOnly).isValid()) {
        this.dateValue = '';
        return;
      }

      // 指定の形式にフォーマット
      const format   = this.$props.format
          .replace('yyyy-MM-dd', 'YYYY-MM-DD');
      this.dateValue = moment(numberHyphenOnly).format(format);
    },
    /**
     * プレースホルダーを生成
     */
    placeholder: function () {
      return this.$props.format.replace(/[a-zA-Z]/g, '0');
    }
  },
  watch  : {
    "dateValue": function (value) {
      this.formatDateValue(value);
    },
  }
}
</script>

<style lang="scss" scoped>
main {
  width: 100%;
}

::v-deep(input) {
  position: absolute;
  border: none;
  width: 100%;
  font-size: 1.15em;
}

::v-deep(input:focus) {
  outline: none;
}

.vdp-datepicker ::v-deep .vdp-datepicker__clear-button {
  position: relative;
  float: right;
}

</style>
